export enum TrackingEvent {
  LOANSELECTOR_AMOUNT_ONINTERACT = 'loanselector_amount_oninteract',
  LOANSELECTOR_TERM_ONINTERACT = 'loanselector_term_oninteract',
  LOANSELECTOR_PURPOSE_ONINTERACT = 'loanselector_purpose_oninteract ',
  LOANSELECTOR_INITIALPAYMENT_ONINTERACT = 'loanselector_initialpayment_oninteract',
  LOANSELECTOR_VEHICLEPRICE_ONINTERACT = 'loanselector_vehicleprice_oninteract',
  LOANSELECTOR_FORM_ONSUBMIT = 'loanselector_form_onsubmit',
  PHONEBOX_BUTTON_ONINTERACT = 'phonebox_button_oninteract',
  LOGIN_LINK_ONINTERACT = 'login_link_oninteract',
  LOGIN_LINK_ONINTERACT_MOBILE = 'login_link_oninteract_mobile',
  ERRORPAGE_HOMEBUTTON_ONINTERACT = 'errorpage_homebutton_oninteract',
  ADVANTAGES_BUTTON_ONINTERACT = 'advantages_button_oninteract',
  OPTIMIZELY_EXPERIMENT_VIEWED = 'Experiment Viewed',
  STEPEXPLANATION_BUTTON_ONINTERACT = 'stepexplanation_button_oninteract',
  FAQ_BUTTON_ONINTERACT = 'faq_button_oninteract',
  MOBILE_HEADER_MENULINK_ONINTERACT = 'mobile_header_menulink_oninteract',
  IMAGE_BUTTON_ONINTERACT = 'image_button_oninteract',
  CONTACT_PHONE_BUTTON_ONINTERACT = 'contact_phone_button_oninteract',
  CONTACT_EMAIL_BUTTON_ONINTERACT = 'contact_email_button_oninteract',
  WIDERRUF_BUTTON_CLICKED = 'widerruf_button_clicked',
  LOAN_VOLUME = 'loanVolume',
  UNSUBSCRIBE_DATA_ONCHANGE = 'unsubscribe_data_onchange',
  REDIRECT_TO_APP = 'redirect_to_app',
  APP_CLOSE_STICKY_BANNER = 'app_close_sticky_banner',
  APP_CLOSE_BOTTOM_BANNER = 'app_close_bottom_banner',
  APP_CLOSE_OVERLAY = 'app_close_overlay',
  APP_BOTTOM_BANNER_VIEWED = 'app_bottom_banner_viewed',
  BANK_LIST_LINK_CLICKED = 'vermittler_link_clicked',
  GUARANTEE_BADGE_CLICKED = 'guarantee_badge_clicked',
  GUARANTEE_BADGE_LINK_CLICKED = 'guarantee_badge_link_clicked',
  WEB_VITALS = 'web_vitals',
  AI_CHAT_BACK_BUTTON_CLICKED = 'ai_chat_back_button_clicked',
  AI_CHAT_DESIRED_MONTHLY_RATE_COMPARED = 'ai_chat_desired_monthly_rate_compared',
  AI_CHAT_EMAIL_ENTERED = 'ai_chat_email_entered',
  AI_CHAT_EMAIL_REQUESTED = 'ai_chat_email_requested',
  AI_CHAT_LOAN_ENTERED = 'ai_chat_loan_entered',
  AI_CHAT_LOAN_OVERVIEW_ENTERED = 'ai_chat_loan_overview_entered',
  AI_CHAT_LOAN_SELECTION_LOAN_EDIT_CLICKED = 'ai_chat_loan_selection_loan_edit_clicked',
  AI_CHAT_LOAN_SELECTION_LOAN_INTEREST_RATE_CHANGED = 'ai_chat_loan_selection_loan_interest_rate_changed',
  AI_CHAT_LOAN_SELECTION_LOAN_MONTHLY_PAYMENT_CHANGED = 'ai_chat_loan_selection_loan_monthly_payment_changed',
  AI_CHAT_LOAN_SELECTION_LOAN_REMAINING_AMOUNT_CHANGED = 'ai_chat_loan_selection_loan_remaining_amount_changed',
  AI_CHAT_LP_LOAN_AMOUNT_CHANGED = 'ai_chat_lp_loan_amount_changed',
  AI_CHAT_PILL_BUTTON_CLICKED = 'ai_chat_pill_button_clicked',
  AI_CHAT_LEGAL_LINK_CLICKED = 'ai_chat_legal_link_clicked',
  AI_CHAT_NAME_ENTERED = 'ai_chat_name_entered',
  AI_CHAT_NEXT_BUTTON_CLICKED = 'ai_chat_next_button_clicked',
  AI_CHAT_LEAD = 'all_lead_ai_consolidation',
  AI_CHAT_PHASE_ENTERED = 'ai_chat_phase_entered',
  AI_CHAT_PHONE_ENTERED = 'ai_chat_phone_entered',
}
